export default {
  ACCESS_TYPES: Object.freeze({
    STUDENT: "student",
    TUTOR: "tutor",
    ADMIN: "administrator"
  }),
  COURSE_COLORS: Object.freeze(["#73cc8b", "#ff8880", "#74b8db", "#e7f878"]),
  EXAM_SECTIONS: Object.freeze({
    SAT: Object.freeze({
      SECTIONS: ["Math", "Verbal"],
      SUBSECTIONS: {
        MATH: ["No Calculator", "Calculator"],
        VERBAL: ["Reading", "Writing"]
      }
    }),

    ACT: Object.freeze({
      SECTIONS: ["English", "Math", "Reading", "Science"]
    })
  }),
  SESSION_REPORTS: Object.freeze({
    REPORT_PLACEHOLDER:
      "This course hasn't met for any sessions yet. Once it has, you'll find a summary of the material covered here",
    ASSIGNMENT_PLACEHOLDER:
      "This is where you'll find your assignment, which should be completed before your next session"
  }),
  STATES: Object.freeze([
    "AL",
    "AK",
    "AS",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FM",
    "FL",
    "GA",
    "GU",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MH",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "MP",
    "OH",
    "OK",
    "OR",
    "PW",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VI",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
  ])
};
